import { useMemo } from 'react';
import { GetUsersInLocationsResponse, StatusType } from '@weave/schema-gen-ts/dist/schemas/auth-api/v3/auth.pb';
import { UsersQueries } from '@frontend/api-users';

type UseOfficeUsersParams = {
  locationIds: string[];
};

type UseOfficeUsersResult = {
  activeOfficeUsers: Record<string, string>;
  isLoading: boolean;
  officeUsers: GetUsersInLocationsResponse['users'];
};

export const useOfficeUsers = ({ locationIds }: UseOfficeUsersParams): UseOfficeUsersResult => {
  const { data: officeUsersResponse, isLoading } = UsersQueries.useGetUsersInLocations(
    locationIds.length > 0 ? locationIds : []
  );

  const officeUsers = useMemo(() => {
    return (officeUsersResponse as GetUsersInLocationsResponse)?.users || [];
  }, [officeUsersResponse]);

  const activeOfficeUsers = useMemo(() => {
    return officeUsers
      .filter(({ status }) => !status || status === StatusType.ACTIVE)
      .reduce((acc, { firstName = '', lastName = '', userId = '' }) => {
        if (userId) {
          acc[userId] = `${firstName} ${lastName}`.trim();
        }
        return acc;
      }, {} as Record<string, string>);
  }, [officeUsers]);

  return {
    activeOfficeUsers,
    isLoading,
    officeUsers,
  };
};
